// @flow
import { type ProductType } from 'common/enums/Product';

type AppConfig = {
    name: string,
    version: string,
    products: Array<ProductType>,
    bugsnagApiKey: string
};

class MFETrackerService {
    apps: Array<AppConfig> = [];

    registerApp(config: AppConfig): void {
        if (this.isAppRegistered(config.name)) {
            return;
        }
        this.apps.push(config);
    }

    getAppConfig(product: ProductType): ?ProductConfig {
        return this.apps.find(item => item.products.includes(product));
    }

    getRegisteredApps(): Array<AppConfig> {
        return this.apps;
    }

    isAppRegistered(name: ProductType): boolean {
        return this.apps.some(app => app.name === name);
    }
}

export default new MFETrackerService();
